import { LoadableAfterPaint } from '@confluence/loadable';

export { ErrorBoundary, ErrorComponent } from './ErrorBoundary';

export { KnownErrorBoundary } from '@confluence/known-error-boundary';

export {
	isNotFoundError,
	isStatusCodeError,
	getStatusCodeError,
	getStatusCode,
	isTooManyRequestsError,
	isUnauthorizedError as isUnauthenticatedError,
	isExpectedApolloError,
	isConfigMissingSpaceError,
	isConfigUserPermissionError,
	isConfigSpacePermissionError,
	isConfigDeletedSpaceError,
} from '@confluence/error-types';

export {
	UnauthorizedErrorBoundary,
	isUnauthorizedError,
} from '@confluence/unauthorized-error-boundary';

export { withErrorBoundary, withTransparentErrorBoundary } from './withTypedErrorBoundary';

export { TransparentErrorBoundary } from './TransparentErrorBoundary';

export { GenericErrorBoundary } from './GenericErrorBoundary';

export { AtlassianSupportLink, ATLASSIAN_SUPPORT_URL } from './AtlassianSupportLink';

export { Attribution } from './Attribution';

export { ErrorDisplay } from './ErrorDisplay';

export const ErrorSectionMessage = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ErrorSectionMessage" */ './ErrorSectionMessage'))
			.ErrorSectionMessage,
});
